import React, { forwardRef } from 'react';
import {Link as RouterLink} from "react-router-dom";
export const Link = forwardRef((props, ref) => {
    return (
        <RouterLink {...props} to={props.href}/>
    );
});

export default Link;
